module.exports = __webpack_public_path__ + "4aa07ea55097174eb41a61e8bcb22399.png";